import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from "src/app/shared/shared.module";
import { BankFormComponent } from "./bank-form/bank-form.component";
import { BankListComponent } from "./bank-list/bank-list.component";
import { BanKMasterRoutingModule } from "./bank-routing.module";


@NgModule({
    declarations:[
        BankFormComponent,
        BankListComponent
    ],
    imports:[
        CommonModule,
        AngularMaterialModule,
        BanKMasterRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        NgxMatSelectSearchModule,
        SharedModule
    ],
    exports:[]
})
export class BankMasterModule{}